import { TicketDetailPage } from './details/details';
import { TicketAddPage } from './add/add';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { SummaryServiceProvider } from '../../../providers/wh/summary-service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'tickets-list-page',
  templateUrl: 'index.html',
  providers: [SummaryServiceProvider]
})
export class TicketsPage {
  header_data: any;

  d: any; r: string;
  div_: any;

  public start_time: string = '';
  public end_time: any = '';
  public avl_rules: any = "";
  public activeSearch: any;
  public rules_string:any;
  public rules_array:any;
  public avl_rules_input:any;Í
  public pushPage: any;
  public pushPage2:any;
  public input_ticket_number:any;
  public filer_status:any;


  pet: any;
  tickets_data: any = "";
  public drivers_list: any;
  objectKeys = Object.keys;
  constructor(public navCtrl: NavController, public datepipe: DatePipe, public navParams: NavParams, public summaryService: SummaryServiceProvider, public loadingCtrl: LoadingController) {
    this.header_data = { ismenu: true, ishome: false, title: "Tickets", parentReloadData: d => { this.load_tickets_data(true)
     } };
    this.rules_array = [];
    this.avl_rules_input = [];
    this.filer_status='OPEN';

    this.load_tickets_data(true);

    this.div_ = [];
    this.activeSearch = true;
    this.pushPage = TicketAddPage;
    this.pushPage2 = TicketDetailPage;


  }

  searchByStatus(status)
  {
    this.filer_status=status;

    this.load_tickets_data(true);

  }


  load_tickets_data(show_loader) {
    let q: any ='statuses=' + this.filer_status;


    if (this.start_time !== '') {
      q += 'from=' + this.datepipe.transform(this.start_time, 'yyyy-MM-dd');
    }

    if (this.start_time !== '') {
      q += 'to=' + this.datepipe.transform(this.end_time, 'yyyy-MM-dd');
    }

    if (this.avl_rules.length>0) {
      q += '&rules=' + this.avl_rules;
    }





    if (show_loader) {
      let loader = this.loadingCtrl.create({
        content: "Please wait..."
      });
      loader.present();

      this.summaryService.load_tickets_data(q)
        .then(data => {
          this.tickets_data = data;
          //console.log(this.dashboard_data);
          this.pet = "0";
        });

      loader.dismiss();
    }
    else {
      this.summaryService.load_tickets_data(q)
        .then(data => {
          this.tickets_data = data;
          //console.log(this.dashboard_data);
          this.pet = "0";
        });
    }

  }
}


// WEBPACK FOOTER //
// ./src/pages/backoffice/tickets/index.ts